<div [ngSwitch]="res.fieldType">
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>

  <!--HyperLink start-->
  <ng-container *ngSwitchCase="23">
    <div
      [id]="res?.fieldId"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-hyperLink dg-ag-common"
    >
      <a
        [routerLink]="res.attribute?.routerLink"
        [queryParams]="res.attribute?.queryParams"
        [queryParamsHandling]="res.attribute?.queryParamsHandling"
        [replaceUrl]="res.attribute?.replaceUrl"
        [relativeTo]="res.attribute?.relativeTo"
        [skipLocationChange]="res.attribute?.skipLocationChange"
        [preserveFragment]="res.attribute?.preserveFragment"
        [state]="res.attribute?.state"
        [fragment]="res.attribute?.fragment"
        mat-stroked-button
        color="primary"
        [disabled]="res?.attribute?.enableDisable"
      >
        <mat-icon>open_in_new</mat-icon> {{ res.lbl }}
      </a>
    </div>
  </ng-container>

  <!--HyperLink end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Toggle Button start-->
  <ng-container *ngSwitchCase="40">
    <div
      class="dg-appgen-toggle dg-ag-common"
      [id]="res?.fieldId"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      *ngIf="!res?.attribute?.hideShow"
    >
      <div>
        <mat-label class="common-label d-block">{{ res?.lbl }}</mat-label>
        <mat-button-toggle-group
          name="fontStyle"
          aria-label="Toggle Value"
          [(ngModel)]="toggleValue"
          [disabled]="res?.attribute?.enableDisable"
          class="toggleButton"
          (ngModelChange)="onChangeToggleButton(res, $event)"
        >
          <ng-container
            *ngFor="
              let opt of res?.attribute?.comboMapValues;
              let index = index
            "
          >
            <mat-button-toggle
              [value]="res?.attribute?.comboMapValues[index].optionText"
              (click)="onChangeToggle($event)"
            >
              {{
                res?.attribute?.comboMapValues[index].optionText
              }}</mat-button-toggle
            >
          </ng-container>
        </mat-button-toggle-group>
      </div>
      <mat-hint>{{ res?.attribute?.matHint }}</mat-hint>
    </div>
  </ng-container>

  <!--Toggle Button start-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-divider start-->

  <ng-container *ngSwitchCase="100">
    <div
      [id]="'comp' + res?.fieldId"
      [ngClass]="res?.attribute?.hideShow ? 'd-none' : 'd-block'"
      class="dg-appgen-divider dg-ag-common"
    >
      <div *ngIf="res.attribute?.dividerType == 'inset'">
        <mat-divider [inset]="true" class="my-3"></mat-divider>
      </div>
      <div *ngIf="res.attribute?.dividerType == 'Simple'">
        <mat-divider class="my-3"></mat-divider>
      </div>
      <div *ngIf="res.attribute?.dividerType == 'vertical'">
        <mat-divider [vertical]="true" class="my-3"></mat-divider>
      </div>
    </div>
  </ng-container>

  <!--Mat-divider end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--ckeditor start-->

  <ng-container *ngSwitchCase="90">
    <ng-container *ngIf="isVisible()">
      <div
        [ngClass]="res.attribute.className ? res.attribute.className : ''"
        *ngIf="!res?.attribute?.hideShow"
        class="dg-appgen-ckeditor dg-ag-common"
      >
        <mat-label class="common-label">{{ res.lbl }}</mat-label>
        <ckeditor
          [id]="res?.fieldId"
          [placeholder]="res.attribute?.placeholder"
          [config]="editorConfig"
          [(ngModel)]="mycontent"
          [readOnly]="res?.attribute?.enableDisable"
          (change)="onEditor($event)"
          class="my-1"
        >
        </ckeditor>
      </div>
    </ng-container>
  </ng-container>
  <!--ckeditor end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-icon start-->

  <mat-icon
    *ngSwitchCase="91"
    [id]="res?.fieldId"
    [ngClass]="res?.attribute?.hideShow ? 'd-none' : 'd-block'"
    [matTooltip]="res.attribute?.matTooltip"
    [matTooltipPosition]="res.attribute?.matTooltipPosition"
    class="dg-appgen-maticon dg-ag-common"
  >
    {{ res.attribute?.iconName }}</mat-icon
  >
  <!--Mat-icon end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-Label start-->

  <ng-container *ngSwitchCase="24">
    <mat-label
      class="dg-appgen-matlabel dg-ag-common common-label"
      [id]="res?.fieldId"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      *ngIf="!res?.attribute?.hideShow"
    >
      {{ res.lbl }}</mat-label
    >
  </ng-container>

  <!--Mat-label end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--button start-->
  <ng-container *ngSwitchCase="99">
    <ng-container *ngIf="commonService?.isCaseForm">
      <button
        mat-raised-button
        [id]="res?.fieldId"
        [ngClass]="res.attribute.className ? res.attribute.className : ''"
        *ngIf="!res?.attribute?.hideShow"
        color="primary"
        (click)="onClick()"
        [disabled]="checkDisable()"
        class="dg-appgen-button dg-ag-common"
      >
        {{ res.attribute.label }}
      </button>
      <div class="d-inline-block" *ngIf="checkDisable()">
        <mat-icon
          *ngIf="
            !res?.attribute?.hideShow &&
            buttonSubmit &&
            !commonService.appGenFormGroup.valid
          "
          matTooltip="{{ invalidObj }}"
          matTooltipClass="example-tooltip-red"
          aria-label="{{ invalidObj }}"
          class="example-button dg-fs-14"
          color="warn"
        >
          info
        </mat-icon>
      </div>
    </ng-container>
  </ng-container>
  <!--button end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-Date-Picker start-->
  <ng-container *ngSwitchCase="79">
    <mat-form-field
      [id]="res?.fieldId"
      [ngClass]="
        res.attribute.className ? res.attribute.className : 'appgen-w-35'
      "
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-dateTime dg-ag-common"
    >
      <mat-label
        [ngClass]="res?.attribute?.isMandatory ? 'required-field' : ''"
        >{{ res?.lbl }}</mat-label
      >
      <input
        matInput
        [ngxMatDatetimePicker]="picker"
        placeholder="Choose a date"
        [formControl]="datePickerControl"
        [min]="minDate"
        [max]="maxDate"
        [disabled]="res?.attribute?.enableDisable"
        (ngModelChange)="onChangeDateTime(res, $event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"
        [disabled]="res?.attribute?.enableDisable"
      >
      </mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker> </ngx-mat-datetime-picker>
      <mat-error
        *ngIf="res?.attribute?.isMandatory"
        >{{res?.attribute?.validations?.[0]?.errorMessage}}</mat-error
      >

      <mat-error
        *ngIf="
          !datePickerControl.valid &&
          (datePickerControl.dirty || datePickerControl.touched) &&
          !res?.attribute?.isMandatory
        "
      >
        {{res?.attribute?.validations?.[0]?.errorMessage}}</mat-error
      >
    </mat-form-field>
  </ng-container>

  <!--Mat-Date-Picker end-->

  <!-- Time start-->
  <ng-container *ngSwitchCase="16">
    <mat-form-field
      class="dg-appgen-Time dg-ag-common"
      [id]="res?.fieldId"
      [ngClass]="
        res.attribute.className ? res.attribute.className : 'appgen-w-35'
      "
      *ngIf="!res?.attribute?.hideShow"
    >
      <mat-label
        [ngClass]="res?.attribute?.isMandatory ? 'required-field' : ''"
        >{{ res?.lbl }}</mat-label
      >
      <input
        matInput
        placeholder="Choose a time"
        [ngxTimepicker]="default"
        [formControl]="timePickerControl"
        [format]="res?.attribute?.format"
        [disabled]="res?.attribute?.enableDisable"
        readonly
      />
      <mat-icon
        color="primary"
        [ngClass]="{ disable: res?.attribute?.enableDisable }"
        matSuffix
        (click)="openFromIcon(default)"
        >watch_later</mat-icon
      >

      <ngx-material-timepicker
        #default
        (timeSet)="onChangeTime(res, $event)"
      ></ngx-material-timepicker>

      <mat-error
        *ngIf="res?.attribute?.isMandatory"
        >{{res?.attribute?.validations?.[0]?.errorMessage}}</mat-error
      >

      <mat-error
        *ngIf="
          !timePickerControl.valid &&
          (timePickerControl.dirty || timePickerControl.touched) &&
          !res?.attribute?.isMandatory
        "
      >
        {{res?.attribute?.validations?.[0]?.errorMessage}}</mat-error
      >
    </mat-form-field>
  </ng-container>

  <!-- Time end -->

  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-Autocomplete start-->

  <mat-form-field
    *ngSwitchCase="71"
    class="dg-appgen-autocomplete dg-ag-common"
    [id]="res?.fieldId"
    [ngClass]="res?.attribute?.hideShow ? 'd-none' : 'd-block'"
  >
    <mat-label>{{ res?.attribute?.ariaLabel }}</mat-label>
    <input
      type="text"
      [placeholder]="res?.attribute?.placeholder"
      [aria-label]="res?.attribute?.ariaLabel"
      [showPanel]="res?.attribute?.showPanel"
      [isOpen]="res?.attribute?.open"
      [disableRipple]="res?.attribute?.disableRipple"
      matInput
      [formControl]="autocompleteControl"
      [matAutocomplete]="auto"
      [disabled]="res?.attribute?.enableDisable"
    />
    <mat-autocomplete
      (optionSelected)="selectOption($event, res.fieldId)"
      [autoActiveFirstOption]="res?.attribute?.autoActiveFirstOption"
      [autoSelectActiveOption]="res?.attribute?.autoSelectActiveOption"
      [disableRipple]="res?.attribute?.disableRipple"
      #auto="matAutocomplete"
    >
      <mat-option
        *ngFor="let option of filteredOptions"
        [value]="option?.optionText"
      >
        {{ option?.optionText }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!--Mat-Autocomplete end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Mat-chip-list start-->
  <ng-container *ngSwitchCase="74">
    <mat-form-field
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      class="dg-appgen-matchip dg-ag-common"
    >
      <mat-label>{{ res?.attribute?.lbl }}</mat-label>
      <mat-chip-list
        #chipList
        [ariaOrientation]="res?.attribute?.ariaOrientation"
        [focused]="res?.attribute?.focused"
        [errorState]="res?.attribute?.errorState"
        aria-label="Data selection"
        [disabled]="res?.attribute?.enableDisable"
      >
        <mat-chip
          [removable]="res?.attribute?.removable"
          [selectable]="res?.attribute?.selectable"
          *ngFor="let data of res?.attribute?.dataList"
          (removed)="remove(data)"
        >
          {{ data.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <input
          [placeholder]="res?.attribute?.placeholder"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-list>
    </mat-form-field>
  </ng-container>

  <!--Mat-chip-list end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Ng-select start-->

  <ng-container *ngSwitchCase="81">
    <div
      class="dg-appgen-multiselect dg-ag-common"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      [ngClass]="
        res.attribute.className ? res.attribute.className : 'appgen-w-35'
      "
    >
      <mat-label
        class="common-label"
        [ngClass]="res?.attribute?.isMandatory ? 'required-field' : ''"
        >{{ res?.attribute.label }}</mat-label
      >

      <ng-select
        [items]="res?.attribute?.comboMapValues"
        bindLabel="optionText"
        bindValue="optionValue"
        placeholder="{{ res?.attribute.placeholder }}"
        [selectableGroup]="true"
        [closeOnSelect]="true"
        [disabled]="res?.attribute?.enableDisable"
        [selectableGroupAsModel]="true"
        [(ngModel)]="res.attribute.MultiselectValue"
        (change)="onChangeSelect(res, $event)"
        multiple="true"
      >
      </ng-select>
      <mat-hint>{{ res?.attribute?.matHint }}</mat-hint>
    </div>
  </ng-container>

  <!--Ng-select end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Dg-address start-->
  <ng-container *ngSwitchCase="51">
    <dg-address
      [addressType]="res?.attribute?.addressType"
      [addressCode]="res.defaultValue"
      [inputJson]="addressData"
      (output)="getAddressOutput($event, res.fieldId)"
      class="dg-appgen-address dg-ag-common"
      [id]="res?.fieldId"
      [readOnly]="res?.attribute?.enableDisable"
      *ngIf="!res?.attribute?.hideShow"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      [showResetButton]="!res?.attribute?.enableDisable"
    >
    </dg-address>
  </ng-container>

  <!--Dg-address end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Dynamic-grid start-->
  <ng-container *ngSwitchCase="12">
    <dynamic-grid
      #dynamicGrid
      [rows]="roAr[res?.fieldId]"
      [cols]="colAr[res?.fieldId]"
      [isEditable]="res?.attribute?.isEditable"
      [showSearch]="res?.attribute?.showSearch"
      [isRowSelectable]="res?.attribute?.isRowSelectable"
      [canAddRow]="res?.attribute?.canAddRow"
      [colPropConfig]="colPropConfig"
      [canEditInline]="res?.attribute?.canEditInline"
      [colWidthInPercentage]="true"
      (onActionPerformed)="onActionPerformed($event, res.fieldId)"
      (onLinkClick)="onLinkClick($event)"
      (onInputChange)="onGridInputChange($event)"
      [id]="'appgen-' + res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-dynamicGrid dg-ag-common"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
    ></dynamic-grid>
  </ng-container>

  <!--Dynamic-grid end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Dg-file-upload start-->
  <ng-container *ngSwitchCase="25">
    <dg-file-upload
      #appgenFileUpload
      [profileAttachment]="res.attribute.profileAttachment"
      [isPreview]="res.attribute.preview"
      [cardAttachment]="res.attribute.cardAttachment"
      [singleAttachComponent]="res.attribute.singleAttachComponent"
      [compactView]="res.attribute.compactView"
      [isMobileView]="res.attribute.mobileView"
      [isResolutionCheck]="res.attribute.resolutionCheck"
      [minResHeight]="res.attribute.minResHeight"
      [minResWidth]="res.attribute.minResWidth"
      [maxResHeight]="res.attribute.maxResHeight"
      [maxResWidth]="res.attribute.maxResWidth"
      [isStandalone]="res.attribute.standalone"
      [signatureBox]="res.attribute.signatureBox"
      [isPreviewIcon]="res.attribute.previewIcon"
      [previousPath]="res.attribute.previousPath"
      [multiple]="res.attribute.isMultiple"
      [edit]="res.attribute.edit"
      [acceptedType]="res.attribute.acceptedType"
      [attachId]="res.attribute.attachId"
      [maxSize]="res.attribute.maxSize"
      [maxfiles]="res.attribute.maxfiles"
      (finalPath)="onFinalPath($event, res.fieldId)"
      [title]="res.lbl"
      [uniqueAttachmentId]="res.attribute.uniqueAttachmentId"
      [allowUpdate]="res.attribute.allowUpdate"
      [allowFileToAttach]="
        res.attribute.isView && !res.attribute.allowFileToAttach
          ? false
          : !res?.attribute?.enableDisable
      "
      [allowDelete]="res.attribute.allowDelete"
      [mandatory]="res.attribute.isMandatory"
      [refreshAttachComponent]="res.attribute.refreshAttachComponent"
      [attachSmall]="res.attribute.attachSmall"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-fileUpload dg-ag-common"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
    >
    </dg-file-upload>
  </ng-container>

  <!--Dg-file-upload end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Dg-questionnaire start-->
  <ng-container *ngSwitchCase="103">
    <dg-questionnaire
      [surveyId]="res.attribute.questionnaireId"
      [transactionId]="res.defaultValue"
      [showInternalActionButtons]="false"
      (onAnswerChange)="answerChange($event)"
      [parentEvent]="parentEvent"
      (onParentClickEvent)="onParentClick($event)"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-questionnaire dg-ag-common"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
    >
    </dg-questionnaire>
  </ng-container>

  <!--Dg-questionnaire end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>

  <!--Dg-employee start-->

  <ng-container *ngSwitchCase="111">
    <div
      class="px-2"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      [ngClass]="
        res.attribute.className ? res.attribute.className : 'appgen-w-35'
      "
      class="dg-appgen-employeeSearch dg-ag-common"
    >
      <mat-label
        class="common-label"
        [ngClass]="res?.attribute?.isMandatory ? 'required-field' : ''"
        >{{ res?.attribute?.lbl }}</mat-label
      >

      <dg-employee-search
        #emp
        [empConfig]="empConfig"
        [orgConfig]="orgConfig"
        (change)="onChangeEmp(res, $event)"
        (output)="getDataEmp($event)"
        [enableAddress]="false"
        [addressType]="3"
        class="employee-srch"
      >
      </dg-employee-search>
    </div>
    <mat-card class="dg-bg-light mb-4 mx-2" *ngIf="showReadOnly">
      <mat-card-content>
        <div class="row">
          <div class="col">
            <mat-label class="dg-txt-primary dg-h-18">Employee</mat-label>
            <p class="dg-fs-16">{{ empName }}</p>
          </div>
          <div class="col">
            <mat-label class="dg-txt-primary dg-h-18">Location</mat-label>
            <p class="dg-fs-16">{{ emplocation }}</p>
          </div>
          <div class="col">
            <mat-label class="dg-txt-primary dg-h-18">District</mat-label>
            <p class="dg-fs-16">{{ empdistrict }}</p>
          </div>
          <div class="col">
            <mat-label class="dg-txt-primary dg-h-18">Designation</mat-label>
            <p class="dg-fs-16">{{ empdesignation }}</p>
          </div>
          <div class="col">
            <mat-label class="dg-txt-primary dg-h-18">GPF</mat-label>
            <p class="dg-fs-16">{{ empgpf_number }}</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!--Dg-employee end-->

  <!--Dg-grid start-->
  <ng-container *ngSwitchCase="83">
    <dg-grid
      #table
      [gridConfig]="res?.attribute?.gridConfig[0]"
      (output)="getData2($event)"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-dgGrid dg-ag-common"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
    >
    </dg-grid>
  </ng-container>

  <!--Dg-grid end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Dg-listbox start-->
  <ng-container *ngSwitchCase="87">
    <dg-listbox
      [content]="dataSourceJ[res.fieldId]"
      [columnConfig]="res.attribute.columnConfig"
      [isSelectable]="res.attribute.isSelectable"
      [multiple]="true"
      [pageSizeOption]="res.attribute.pageSizeOption"
      [id]="res?.fieldId"
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-dgListBox dg-ag-common"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
    >
      <ng-container class="listbox-search-placeholder"> Search </ng-container>
    </dg-listbox>
  </ng-container>

  <!--Dg-Listbox end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Note start-->

  <ng-container *ngSwitchCase="104">
    <div
      *ngIf="!res?.attribute?.hideShow"
      class="dg-appgen-Note dg-ag-common"
      [ngClass]="
        res.attribute.className ? res.attribute.className : 'mb-4 appgen-w-35'
      "
      [id]="res?.fieldId"
    >
      <div class="row">
        <div class="">
          <div class="user-note-outer info-note">
            <div class="user-note-content-outer">
              <p class="user-note-heading" *ngIf="!res?.attribute?.hideLabel">
                <mat-icon class="dg-txt-primary dg-fs-16">info</mat-icon
                ><span class="dg-h-20">{{ res.attribute.label }}</span> :
              </p>
              <div
                class="note-body px-4"
                [innerHTML]="convertToHtml(res.attribute.content)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Custom component -->
  <ng-container *ngSwitchCase="108">
    <div
      *ngIf="checkDisplayDevForm(this.res?.attribute?.fieldId)"
      [ngClass]="res.attribute.className ? res.attribute.className : ''"
      class="dg-appgen-developerForm dg-ag-common developerForm"
    >
      <ng-template
        #customComponent
        (appGenDataEmit)="appGenDataEmitFromCheckList($event)"
        [componentLoader]="demoComponent"
        [componentInputs]="{
          parentCommonService: this.commonService,
          data: this.commonService.inputCaseViewdata,
          parentEventData: this.commonService.parentEventData,
          caseVO: execution.caseVO,
          cases: execution.cases,
          dataForPost: execution.dataForPost,
          menuFetchData: execution.menuFetchData,
          formId: demoFormId,
          appRefId: demoTid,
          additionalVOList: this.commonService.additionalVOList,
          fieldId: res?.fieldId
        }"
        [componentOutputs]="[
          'output',
          'ruleCondition',
          'refreshGrid',
          'appGenDataEmit',
          'hideDevForm'
        ]"
        (output)="getChckLstComponentData($event)"
        [ngClass]="res?.attribute?.hideShow ? 'd-none' : 'd-block'"
      ></ng-template>
    </div>
  </ng-container>

  <!--Note end-->
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!------------------------------------------------------------------------------------------------------>
  <!--Html-content start-->

  <div
    class="dg-appgen-htmlContent dg-ag-common htmlContent"
    *ngSwitchCase="105"
    [id]="res?.fieldId"
    [ngClass]="res?.attribute?.hideShow ? 'd-none' : 'd-block'"
  >
    <div class="htmContentHeading dg-h-20" *ngIf="!res?.attribute?.hideLabel">
      {{ res.attribute.label }}
    </div>
    <div
      class="htmContentbody"
      [innerHTML]="convertToHtml(res.attribute.content)"
    ></div>
  </div>

  <!--Html-content end-->
</div>
